import * as actions from "../actions/chat";

export const INITIAL_STATE = {
  chatSession: null,
  chatID: 0,
  initialMessage: null,
  sending: false,
  usage: null,
};

const chat = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.SET_ACTIVE_CHAT_SESSION: {
      return {
        ...state,
        chatSession: action.chatSession,
      };
    }
    case actions.SET_ACTIVE_CHAT_ID: {
      return {
        ...state,
        chatID: action.chatID,
        initialMessage: action.initialMessage,
      };
    }
    case actions.ADD_CHAT_MESSAGE: {
      console.log("ACTIVE CHAT: ", action);
      const chatSession = { ...state.chatSession };
      if (!chatSession.messages) chatSession.messages = [];
      chatSession.messages = [...chatSession.messages, action.message];

      return {
        ...state,
        chatSession: chatSession,
      };
    }

    case actions.DELETE_CHAT_MESSAGE: {
      const chatSession = { ...state.chatSession };
      chatSession.messages = chatSession.messages.filter(
        (m) => m.public_id !== action.message_id
      );

      return {
        ...state,
        chatSession: chatSession,
      };
    }

    case actions.ADD_CHAT_RESPONSE: {
      const chatSession = { ...state.chatSession };
      const userMessage = action.chatResponse?.user_message;
      const agentMessage = action.chatResponse.agent_message;

      // There is a chance we don't have a user message if it's button response
      if (userMessage) {
        chatSession.messages.forEach((m) => {
          if (m.message === userMessage.message && !m.id) {
            m.public_id = userMessage.public_id;
          }
        });
      }

      chatSession.messages = [...chatSession.messages, agentMessage];
      console.log("CHAT SESSION MESSAGES: ", chatSession.messages);
      return {
        ...state,
        chatSession: chatSession,
      };
    }
    case actions.SENDING_CHAT_MESSAGE: {
      return {
        ...state,
        sending: action.sending,
      };
    }
    case actions.CLEAR_CHAT_SESSION: {
      return {
        ...state,
        chatSession: null,
        chatID: 0,
        initialMessage: null,
        sending: false,
        usage: null,
      };
    }
    case actions.SET_ACTIVE_CHAT_USAGE: {
      return {
        ...state,
        usage: action.usage,
      };
    }
    default:
      return state;
  }
};

export default chat;
